import { render, staticRenderFns } from "./TrustedSenders.vue?vue&type=template&id=34ab8f90"
import script from "./TrustedSenders.vue?vue&type=script&lang=js"
export * from "./TrustedSenders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports